export default "__VITE_ASSET__4ff682de__$_?nuxt_component=async&nuxt_component_name=SvgoClockOutline__"